import { PLAN_PRO } from '@/constants/userSubscriptionPlans'
import { PERMISSION_TYPE, type PERMISSION_VALUE } from '@/permissions'
import { ROLE_TYPE } from '../permissions'

export enum SEO_TAGS_PERMISSION {
  EDIT = 'SEO_TAGS_EDIT',
}

export const getSeoTagsPermissionsMatrix = (): Record<
  SEO_TAGS_PERMISSION,
  Record<ROLE_TYPE, PERMISSION_VALUE>
> => {
  return {
    [SEO_TAGS_PERMISSION.EDIT]: {
      [ROLE_TYPE.TRIAL_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.TRIAL_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_ANONYMOUS]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_LOGGED]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.FREE_OWNER]: {
        type: PERMISSION_TYPE.NA_BADGE,
        badge: PLAN_PRO,
      },
      [ROLE_TYPE.PRO_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_PROJECT_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.PRO_OWNER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_ANONYMOUS]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_LOGGED]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_PROJECT_MEMBER]: {
        type: PERMISSION_TYPE.YES,
      },
      [ROLE_TYPE.TEAM_AGENCY_MEMBER]: { type: PERMISSION_TYPE.YES },
      [ROLE_TYPE.TEAM_AGENCY_OWNER]: { type: PERMISSION_TYPE.YES },
    },
  }
}
